import axios, { microServices } from './axios'
import { loaders } from './../constants'

const GLOBAL_FEATURE_FLAGS = '/global-feature-flags'
const ACCOUNT_FEATURE_FLAGS = (accountId) => `/global-accounts/${accountId}/feature-flags`

export const getGlobalFeatureFlags = async () => {
  return await axios('get', GLOBAL_FEATURE_FLAGS, {}, { loader: loaders.OVERLAY, server: microServices.DE }).then(
    data => data,
    error => new Promise((resolve, reject) => reject(error))
  )
}

export const updateGlobalFeatureFlag = async (key, value) => {
  return await axios('patch', `${GLOBAL_FEATURE_FLAGS}/${key}`, { value }, { loader: loaders.OVERLAY, server: microServices.DE }).then(
    data => data,
    error => new Promise((resolve, reject) => reject(error))
  )
}

export const getGlobalFeatureFlagAccounts = async (key) => {
  return await axios('get', `${GLOBAL_FEATURE_FLAGS}/${key}/accounts`, {}, { loader: loaders.OVERLAY, server: microServices.DE }).then(
    data => data,
    error => new Promise((resolve, reject) => reject(error))
  )
}

export const getAccountFeatureFlags = async (accountId) => {
  return await axios('get', ACCOUNT_FEATURE_FLAGS(accountId), {}, { loader: null, showError: false, server: microServices.DE }).then(
    data => data,
    error => new Promise((resolve, reject) => reject(error))
  )
}

export const updateAccountFeatureFlags = async (accountId, overrides) => {
  return await axios('patch', ACCOUNT_FEATURE_FLAGS(accountId), overrides, { loader: loaders.OVERLAY, server: microServices.DE }).then(
    data => data,
    error => new Promise((resolve, reject) => reject(error))
  )
}
